"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _store = require("@/api/store");
var _categoryApi = require("@/api/categoryApi");
var _suplierCouponsApi = require("@/api/suplierCouponsApi");
var _enum = require("../../enum");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var props = {
  children: 'child',
  label: 'name',
  value: 'id',
  emitPath: false
};
function _default(_ref) {
  var handleSearch = _ref.handleSearch;
  // 获取 userType 判断是否显示运营平台
  var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo') || '{}');
  var userType = JavaInfo.type;
  var FILTER_ITEMS = [{
    type: 'select',
    label: '商品类型：',
    prop: 'productType',
    attrs: {
      placeholder: '请选择商品类型',
      props: props,
      size: 'small',
      filterable: true,
      clearable: true
    },
    options: _enum.goodsTypeFilterEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          productType: value
        });
      }
    }
  }, {
    type: 'cascader',
    label: '商品分类：',
    prop: 'cateId',
    attrs: {
      placeholder: '请选择商品分类：',
      props: _objectSpread(_objectSpread({}, props), {}, {
        checkStrictly: true
      }),
      clearable: true,
      size: 'small',
      options: []
    },
    events: {
      change: function change(value) {
        return handleSearch({
          cateId: value
        });
      }
    }
  }, {
    type: 'cascader',
    label: '展示分类：',
    prop: 'showCateId',
    attrs: {
      placeholder: '请选择展示分类',
      props: _objectSpread(_objectSpread({}, props), {}, {
        multiple: true,
        checkStrictly: true
      }),
      clearable: true,
      size: 'small',
      options: []
    },
    events: {
      change: function change(value) {
        return handleSearch({
          showCateId: value
        });
      }
    }
  }, {
    type: 'cascader',
    label: '产地：',
    prop: 'areaId',
    attrs: {
      placeholder: '请选择产地',
      props: _objectSpread(_objectSpread({}, props), {}, {
        checkStrictly: true
      }),
      clearable: true,
      size: 'small',
      options: []
    },
    events: {
      change: function change(value) {
        return handleSearch({
          areaId: value
        });
      }
    }
  }, {
    type: 'select',
    // 输入框
    label: '供应商：',
    prop: 'supplierId',
    attrs: {
      placeholder: '请选择供应商',
      props: props,
      size: 'small',
      filterable: true,
      remote: true,
      clearable: true,
      'remote-method': getSupplierList
    },
    options: [],
    events: {
      change: function change(value) {
        return handleSearch({
          supplierId: value
        });
      }
    }
  }, {
    type: 'select',
    label: '商品品牌：',
    prop: 'brandId',
    attrs: {
      placeholder: '请选择商品品牌',
      props: props,
      size: 'small',
      // // filterable: true,
      remote: true,
      clearable: true,
      'remote-method': getBrandList
    },
    options: [],
    events: {
      change: function change(value) {
        return handleSearch({
          brandId: value
        });
      }
    }
  }, {
    type: 'select',
    label: '维护人：',
    prop: 'maintainerId',
    attrs: {
      placeholder: '请选择维护人',
      size: 'small',
      filterable: true,
      remote: true,
      clearable: true,
      'remote-method': getMaintainerOptions
    },
    options: [],
    events: {
      change: function change(value) {
        return handleSearch({
          maintainerId: value
        });
      }
    }
  },
  // 商品标签字段隐藏
  // {
  //   type: 'select',
  //   label: '商品标签：',
  //   prop: 'labelId',
  //   attrs: {
  //     placeholder: '请选择商品标签',
  //     props,
  //     size: 'small',
  //     remote: true,
  //     clearable: true,
  //     'remote-method': getLabelList,
  //   },
  //   options: [],
  //   events: { change: (value) => handleSearch({ labelId: value }) },
  // },
  {
    type: 'input',
    label: 'SPU ID：',
    prop: 'spuId',
    attrs: {
      placeholder: '请输入SPU ID',
      clearable: true,
      size: 'small'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          spuId: value
        });
      }
    }
  }, {
    type: 'input',
    label: 'SPU名称：',
    prop: 'spuName',
    attrs: {
      placeholder: '请输入SPU名称',
      clearable: true,
      size: 'small'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          spuName: value
        });
      }
    }
  }, {
    type: 'input',
    label: 'SPU编码：',
    prop: 'spuCode',
    attrs: {
      placeholder: '请输入SPU编码',
      clearable: true,
      size: 'small'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          spuCode: value
        });
      }
    }
  }, {
    type: 'select',
    label: '排序方式：',
    prop: 'orderByType',
    attrs: {
      placeholder: '请选择排序方式',
      props: props,
      size: 'small',
      clearable: true
    },
    options: _enum.orderByTypeEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          orderByType: value
        });
      }
    }
  }, {
    type: 'pickerRange',
    label: '创建时间：',
    prop: 'dateRange',
    attrs: {
      placeholder: '请选择创建时间',
      clearable: true
    },
    events: {
      change: function change(value) {
        return handleSearch({
          dateRange: value
        });
      }
    }
  }, {
    type: 'select',
    label: '审核状态：',
    prop: 'auditStatus',
    attrs: {
      placeholder: '请选择审核状态',
      props: props,
      size: 'small',
      clearable: true
    },
    options: _enum.auditStatusEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          isVerify: value
        });
      }
    }
  }, {
    type: 'select',
    label: '上下架状态：',
    prop: 'isShowStatus',
    attrs: {
      placeholder: '请选择上下架状态',
      props: props,
      size: 'small',
      clearable: true
    },
    options: _enum.isShowFilterEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          isShow: value
        });
      }
    }
  }];

  // 分类
  function getCategorySelect(_x) {
    return _getCategorySelect.apply(this, arguments);
  } // 产地
  function _getCategorySelect() {
    _getCategorySelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
      var res, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return (0, _store.categoryApi)({
              status: -1,
              type: type
            });
          case 1:
            res = _context.v;
            _t = type;
            _context.n = _t === 1 ? 2 : _t === 8 ? 3 : 4;
            break;
          case 2:
            FILTER_ITEMS[1].attrs.options = res || []; // 商品分类 cateId
            return _context.a(3, 5);
          case 3:
            FILTER_ITEMS[2].attrs.options = res || []; // 展示分类 showCateId
            return _context.a(3, 5);
          case 4:
            return _context.a(3, 5);
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t2 = _context.v;
            console.error(_t2);
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _getCategorySelect.apply(this, arguments);
  }
  function getPlaceList() {
    return _getPlaceList.apply(this, arguments);
  } //供应商
  function _getPlaceList() {
    _getPlaceList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var res, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return (0, _store.getCityApi)();
          case 1:
            res = _context2.v;
            FILTER_ITEMS[3].attrs.options = res || []; // 产地 areaId
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t3 = _context2.v;
            console.error(_t3);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return _getPlaceList.apply(this, arguments);
  }
  function getSupplierList() {
    return _getSupplierList.apply(this, arguments);
  } // 品牌
  function _getSupplierList() {
    _getSupplierList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var query,
        params,
        res,
        _args3 = arguments,
        _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            query = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
            params = {
              keyword: query
            };
            _context3.p = 1;
            _context3.n = 2;
            return (0, _store.getSupplierApi)(params);
          case 2:
            res = _context3.v;
            FILTER_ITEMS[4].options =
            // 供应商 supplierId - 固定 index 4
            res.map(function (item) {
              return {
                label: item.supplierName,
                value: item.id
              };
            }) || [];
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t4 = _context3.v;
            console.error(_t4);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return _getSupplierList.apply(this, arguments);
  }
  function getBrandList() {
    return _getBrandList.apply(this, arguments);
  } // 标签
  function _getBrandList() {
    _getBrandList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var query,
        params,
        res,
        brandIndex,
        _args4 = arguments,
        _t5;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            query = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
            params = {
              keyword: query
            };
            _context4.p = 1;
            _context4.n = 2;
            return (0, _store.getBrandrApi)(params);
          case 2:
            res = _context4.v;
            brandIndex = userType === 1 ? 6 : 5; // userType===1时运营平台在index5，品牌移到index6
            FILTER_ITEMS[brandIndex].options = res.map(function (item) {
              return {
                label: item.brandName,
                value: item.id
              };
            }) || [];
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t5 = _context4.v;
            console.error(_t5);
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _getBrandList.apply(this, arguments);
  }
  function getLabelList() {
    return _getLabelList.apply(this, arguments);
  } // 维护人
  function _getLabelList() {
    _getLabelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var query,
        params,
        res,
        labelIndex,
        _args5 = arguments,
        _t6;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            query = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : '';
            params = {
              keyword: query
            };
            _context5.p = 1;
            _context5.n = 2;
            return (0, _store.getLabelApi)(params);
          case 2:
            res = _context5.v;
            labelIndex = userType === 1 ? 8 : 7; // userType===1时标签在index8，否则在index7
            FILTER_ITEMS[labelIndex].options = res.map(function (item) {
              return {
                label: item.labelName,
                value: item.id
              };
            }) || [];
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t6 = _context5.v;
            console.error(_t6);
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return _getLabelList.apply(this, arguments);
  }
  function getMaintainerOptions() {
    return _getMaintainerOptions.apply(this, arguments);
  } // 运营平台
  function _getMaintainerOptions() {
    _getMaintainerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var query,
        params,
        res,
        maintainerIndex,
        _args6 = arguments,
        _t7;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            query = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : '';
            params = query ? query : '';
            _context6.p = 1;
            _context6.n = 2;
            return (0, _suplierCouponsApi.getAllUser)(params);
          case 2:
            res = _context6.v;
            maintainerIndex = userType === 1 ? 7 : 6; // userType===1时维护人在index7，否则在index6
            FILTER_ITEMS[maintainerIndex].options = (res || []).map(function (item) {
              return {
                label: item.realName ? "".concat(item.realName).concat(item.flag == 1 ? '（当前登陆人）' : '') : item.nickName || item.name || '未命名',
                value: item.id
              };
            });
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t7 = _context6.v;
            console.error(_t7);
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return _getMaintainerOptions.apply(this, arguments);
  }
  function getPlatformList() {
    return _getPlatformList.apply(this, arguments);
  } // 根据 userType 添加运营平台搜索项
  function _getPlatformList() {
    _getPlatformList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var query,
        params,
        res,
        _args7 = arguments,
        _t8;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            query = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : '';
            params = {
              keyword: query
            };
            _context7.p = 1;
            _context7.n = 2;
            return (0, _categoryApi.getPlatformOptions)(params);
          case 2:
            res = _context7.v;
            FILTER_ITEMS[5].options =
            // 运营平台 platformId - 固定 index 5
            res.map(function (item) {
              return {
                label: item.appName,
                value: item.customerId
              };
            }) || [];
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t8 = _context7.v;
            console.error(_t8);
          case 4:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return _getPlatformList.apply(this, arguments);
  }
  if (userType === 1) {
    FILTER_ITEMS.splice(5, 0, {
      type: 'select',
      label: '运营平台：',
      prop: 'platformId',
      attrs: {
        placeholder: '请选择运营平台',
        props: {
          label: 'appName',
          value: 'customerId'
        },
        size: 'small',
        remote: true,
        clearable: true,
        'remote-method': getPlatformList
      },
      options: [],
      events: {
        change: function change(value) {
          return handleSearch({
            customerId: value
          });
        }
      }
    });
  }

  // 获取基本数据
  getCategorySelect(1);
  getCategorySelect(8);
  getPlaceList();
  getSupplierList();
  getBrandList();
  getLabelList();
  if (userType === 1) {
    getPlatformList();
  }
  getMaintainerOptions();
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}